import React from "react";
import { css } from "@linaria/core";
import type { ManualEvent } from "../../../../../../../../../../api/useEvents";
import { spacings } from "@ui/Theme";
import { color } from "@ui/index";
import t from "../../../../../../../../../../i18n";

const SidePanelDetails = ({ manualFaultEvent }: { manualFaultEvent: ManualEvent }) => (
  <div className={sidePanelDetailsContainer}>
    <p className={title}>{t("project.fault_event.side_panel.details.fault_name")}</p>
    <p className={value}>{manualFaultEvent.metadata.manualFaultName}</p>
    <p className={title}>{t("project.fault_event.side_panel.details.system")}</p>
    {manualFaultEvent.metadata.manualFault.systemId && (
      <p className={value}>{manualFaultEvent.metadata.manualFault.systemId}</p>
    )}
  </div>
);
export default SidePanelDetails;

//#region CSS
const sidePanelDetailsContainer = css`
  width: 100%;
  height: 100%;
  padding: ${spacings.m};
`;
const value = css`
  margin-top: ${spacings.xxs};
  word-break: break-word;
`;
const title = css`
  white-space: nowrap;
  color: ${color.carbon700};

  &:not(:first-child) {
    margin-top: ${spacings.m};
  }

  &:not(:has(+ .${value})) {
    display: none;
  }
`;

//#endregion CSS
